import { combineReducers } from '@reduxjs/toolkit';
import fuse from './fuse';
import i18n from './i18nSlice';
import user from './userSlice';
import helpers from './helpersSlice';
import auth from './authSlice';
import tabs from './tabsSlice';
import { apiSlice } from '../api/apiSlice';
import customHeaderContent from './customHeaderContentSlice';

const createReducer = (asyncReducers) => (state, action) => {
  const combinedReducer = combineReducers({
    fuse,
    i18n,
    user,
    helpers,
    auth,
    tabs,
    [apiSlice.reducerPath]: apiSlice.reducer,
    customHeaderContent,
    ...asyncReducers,
  });

  return combinedReducer(state, action);
};

export default createReducer;
